export const sampleText = (type) => {
  if (type === "PARTNER_CODE_GROUP") {
    return "CODE001,-1\nCODE002,2\nCODE003,3\nCODE0048,5\nCODE006,3\nCODE007,7\nCODE008,8\nCODE009,9\nCODE010,10";
  }
  return "CODE001,4\nCODE002\nCODE003,\nCODE004,1\nCODE006\nCODE007,10\nCODE008,20\nCODE009,\nCODE010,100";
};
